import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clock, Package, ShoppingCart, Heart, Star } from "lucide-react";
import api from "@/lib/api";
import { PageHeader } from "@/components/ui-helpers";
import { toast } from "sonner";

export default function RecentlyViewedPage() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/marketplace/recently-viewed").then((r) => setItems(r.data.products || [])).catch(() => setItems([])); }, []);

  const addCart = async (id) => {
    try { await api.post("/marketplace/cart/add", { product_id: id, qty: 1 }); window.dispatchEvent(new Event("cart-updated")); toast.success("Added to cart"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not add to cart"); }
  };
  const addWish = async (id) => {
    try { await api.post(`/marketplace/wishlist/${id}`); toast.success("Added to wishlist"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not add"); }
  };
  const disc = (p) => (p.mrp && p.price && p.mrp > p.price ? Math.round(((p.mrp - p.price) / p.mrp) * 100) : 0);

  return (
    <div data-testid="recently-viewed-page">
      <PageHeader title="Recently Viewed" icon={Clock} subtitle="Products you looked at recently — pick up where you left off." />
      {items && items.length === 0 && (
        <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-12 text-center" data-testid="recently-empty">
          <Clock className="mx-auto h-8 w-8 text-slate-300" />
          <p className="mt-3 font-semibold text-slate-700">Nothing here yet</p>
          <button onClick={() => nav("/app/shop")} className="mt-3 rounded-full brand-gradient-bg px-5 py-2 text-sm font-semibold text-white">Start shopping</button>
        </div>
      )}
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5" data-testid="recently-grid">
        {(items || []).map((p) => (
          <div key={p.product_id} className="overflow-hidden rounded-2xl border border-slate-200 bg-white" data-testid={`recent-${p.product_id}`}>
            <div onClick={() => nav(`/product/${p.slug || p.product_id}`)} className="aspect-square cursor-pointer bg-slate-100">
              {p.image || (p.images || [])[0] ? <img src={p.image || p.images[0]} alt={p.name} loading="lazy" className="h-full w-full object-cover" /> : <div className="flex h-full items-center justify-center"><Package className="h-8 w-8 text-slate-300" /></div>}
            </div>
            <div className="p-3">
              <p onClick={() => nav(`/product/${p.slug || p.product_id}`)} className="line-clamp-2 cursor-pointer text-sm font-medium">{p.name}</p>
              <div className="mt-1 flex items-baseline gap-1"><span className="font-bold">₹{Math.round(p.price || 0)}</span>{disc(p) > 0 && <span className="text-xs font-semibold text-emerald-600">{disc(p)}%</span>}</div>
              {(p.rating_avg || p.rating) ? <p className="mt-1 flex items-center gap-1 text-xs text-amber-500"><Star className="h-3 w-3 fill-amber-400" /> {p.rating_avg || p.rating}</p> : null}
              <div className="mt-2 flex gap-1.5">
                <button onClick={() => addCart(p.product_id)} data-testid={`recent-cart-${p.product_id}`} className="inline-flex flex-1 items-center justify-center gap-1 rounded-lg brand-gradient-bg px-2 py-1.5 text-xs font-semibold text-white"><ShoppingCart className="h-3.5 w-3.5" /> Cart</button>
                <button onClick={() => addWish(p.product_id)} data-testid={`recent-wish-${p.product_id}`} className="rounded-lg border border-slate-200 p-1.5 text-slate-400 hover:text-rose-500"><Heart className="h-4 w-4" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
